import { Component, OnInit, inject } from "@angular/core";
import { AppService } from "@core/services/app.service";
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidatorFn, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GlobalHandlerService } from "@core/services/global-handler.service";
import { markFormAsTouched } from "@shared/heplers/helpers";
import { ProductsService } from "@shared/services/products.service";
import { EURO_COIN_SYMBOL, ITALIA } from "@shared/heplers/const-data";
import { ITicket, ITicketsResponse } from "../interfaces/ticket.interface";
import { ISearchParams } from "../interfaces/search.interface";
import { TranslateModule } from "@ngx-translate/core";
import { ManagementCardComponent } from "./management-card/management-card.component";
import { CurvedHeaderComponent } from '@shared/components/curved-header/curved-header.component';

@Component({
    selector: "app-management",
    templateUrl: "./management.component.html",
    styleUrls: ["./management.component.scss"],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ManagementCardComponent,
    TranslateModule,
    CurvedHeaderComponent,
  ]
})
export class ManagementComponent implements OnInit {
  private appService = inject(AppService);
  private formBuilder = inject(UntypedFormBuilder);
  private globalHandlerService = inject(GlobalHandlerService);
  productsService = inject(ProductsService);

  form: UntypedFormGroup;
  isSearchDone = false;
  ticketloading = false;
  loadingItems = false;
  loadedAllItems = false;
  items: ITicket[] = [];
  isLoading : boolean = false;
  isFormValid : boolean = false;
  isWebMobile: boolean = window.innerWidth < 600;

  readonly ITALIA = ITALIA;
  readonly EURO_COIN_SYMBOL = EURO_COIN_SYMBOL;

  ngOnInit() {
    this.form = this.formBuilder.group({
      tiTuiTc: [],
      customerPhone: [],
      email: [],
      ownerName: [],
      ownerSurname: [],
    }, { validator: this.atLeastOneFieldValidator });
  }

  onSearchClick() {
    this.isFormValid = !this.form.valid;
    if (this.form.valid && this.hasBlankValues()) {
      this.reset();
      this.findTickets();
    } else {
      this.reset(true)
      this.isFormValid=true
      markFormAsTouched(this.form);
    }
  }

  truthy(){
    const formValue = this.form.value;
    const truthyValues = Object.keys(formValue).reduce((acc, key) => {
     let value = formValue[key];
      if (value && value.trim() !== '') {
       value = value.trim();
       acc[key] = encodeURIComponent(value);
      }
     return acc;
    }, {});

   return truthyValues;
  }
  
  findTickets() {
    this.isLoading = true;
    const searchParams: ISearchParams = this.truthy();
    let params = '?';
  
    for (const [key, value] of Object.entries(searchParams)) {
      if (value) {
        params += `${key}=${value}&`
      }
    }

    params = params.endsWith('&') ? params.slice(0, -1) : params;

    this.appService
      .getElement(`selling/manage/search${params}`)
      .subscribe(
        (response: ITicketsResponse) => {
          this.isLoading = false;
          this.items = response.elements;
          this.loadedAllItems = true;
          this.loadingItems = false;
          this.isSearchDone = true;
          this.form.reset();
        },
        (error) => {
          this.isLoading = false;
          this.isSearchDone = true;
          this.loadingItems = false;
          this.loadedAllItems = true;
          this.globalHandlerService.showError(error);
        }
      );
  }

  reset(resetForm = false) {
    this.isFormValid = false;
    if (resetForm) {
      this.form.reset();
    }
    this.items = [];
    this.loadedAllItems = false;
    this.isSearchDone = false;
  }

  atLeastOneFieldValidator(group: UntypedFormGroup) {
    const controlValues = Object.values(group.controls);
    const hasValue = controlValues.some(control => !!control.value);
    return hasValue ? null : { atLeastOneFieldRequired: true };
  }

  hasBlankValues() {
    const formValue = this.form.value;
    let hasEmptyValue = false;
    let hasProperValue = false;
  
    for (const key in formValue) {
      if (typeof formValue[key] === 'string') {
        if (formValue[key].trim() === '') {
          hasEmptyValue = true;
        } else {
          hasProperValue = true;
        }
      }
  
      // If we already found both an empty and a proper value, we can stop searching
      if (hasEmptyValue && hasProperValue) {
        break;
      }
    }
  
    // If there's only an empty value, return false
    if (hasEmptyValue && !hasProperValue) {
      return false;
    }
  
    return hasEmptyValue || hasProperValue;
  }
}
